import React, { Component, useState } from 'react';
import { Button, Row, Col, Pagination } from 'react-bootstrap'
import "react-datepicker/dist/react-datepicker.css";
import $, { data } from 'jquery'
import AuthService from "../../controllers/AuthService";
import UserService from "../../controllers/UserService";
import ReportEvaluateStudentList from "../../components/ReportEvaluateStudentList";
import ReportEvaluateTeacherList from "../../components/ReportEvaluateTeacherList";
import ReportEvaluateTeacherList2 from "../../components/ReportEvaluateTeacherList2";
import ReportEvaluateStudentResult from "../../components/ReportEvaluateStudentResult";
import ReportStudentEvaluateTeacher from "../../components/ReportStudentEvaluateTeacher";
import ReportEvaluateTeacher from "../../components/ReportEvaluateTeacher";
import ReportStudentIntro from "../../components/ReportStudentIntro";
import ReportSelfDevelopment from "../../components/ReportSelfDevelopment";
import { withRouter } from 'react-router-dom';
import { Helmet } from "react-helmet";

class ReportFriendshipOverview extends Component {
    constructor(props) {
        super(props);
        this.callbackFromPersonEvaluateReport = this.callbackFromPersonEvaluateReport.bind(this);
        this.callbackFromStudentintro = this.callbackFromStudentintro.bind(this);
        console.log(this.props.match.params.roomId);
        const search = window.location.search;
        const params = new URLSearchParams(search);
        this.state = {
            message: [],
            evaluate1: btnEvaluate1('student'),
            evaluate2: btnEvaluate2('self'),
            filter: [],
            data: null,
            roomId: this.props.match.params.roomId,
            pagination: [],
            user: AuthService.getCurrentUser(),
            role: AuthService.getUserRole(),
            filterStringQ: null,
            tabKey: 'student',
            dataMode: 'student',
            currentStudentId: '',
            currentStudentName: '',
            currentPage: 1,
            textBtn: AuthService.getUserRole() === 'student' ? 'คำตอบของเรา' : 'คำตอบจากนักเรียน',
            classMainBg: 'bg-white',
            classFillter: 'bg-white',
            classShadow: '',
            report1: 'btn-mm-blue',
            report2: 'btn-mm-outline-blue',
            report3: 'btn-mm-outline-blue',
            teacherId: '', //first teacher in room
            menuText: 'ประเมินตัวเอง',
            studentId: params.get('studentId'),
            currentTeacherId: AuthService.getCurrentUserId(), //teacher that login
            currentTeacherName: ''
        };
    }

    componentDidMount() {
        if (this.state.studentId) {

            UserService.getUserById(this.state.studentId).then(
                (res) => {

                    this.setState({
                        currentStudentId: this.state.studentId,
                        currentStudentName: res.data.data.fullName,

                    }, () => {
                        this.updateContent('studentintro');
                        console.log();
                    });

                });

        } else {
            this.setState({ dataMode: 'student' });
            this.studentList();
            this.getFilter('student');
        }


        UserService.getStudentInRoom(this.state.roomId).then(
            (res) => {
                // console.log('roomId');
                // console.log(res.data.data.teachers[0].id);

                this.setState({ teacherId: res.data.data.teachers[0] });

                if (AuthService.getUserRole() !== 'teacher') {

                    this.setState({ menuText: 'ครูประเมินตัวเอง' });
                }
                //this.setState({ teacherId: res.data.data.teachers[0].id }); ==> for block second teacher

                if (AuthService.getUserRole() !== 'headmaster') {
                    this.setState({ teacherId: AuthService.getCurrentUserId() })
                }


            });
    }

    callbackFromPersonEvaluateReport(id, name) {
        // studentintro       
        // console.log('callbackFromPersonEvaluateReport');  
        this.setState({
            currentStudentId: id,
            currentStudentName: name,

        }, () => {
            this.updateContent('studentintro');
        });

    }

    callbackFromStudentintro(code) {
        // studentintro       
        // console.log('callbackFromStudentintro');  
        if (code === 'selfDevelopment') {
            this.updateContent('selfDevelopment', { "code": code });
        } else {
            this.updateContent('studentResult', { "code": code });
        }

    }



    callbackFromStudentEvaluateTeacher(roomid, id, name) {
        console.log('callbackFromStudentEvaluateTeacher');
        this.setState({
            roomId: roomid,
            currentTeacherId: id,
            currentTeacherName: name

        }, () => {
            this.updateContent('studentEvaluateTeacherDetail');
        });

    }


    callbackFromTeacherSelfList(roomid, id, name) {
        console.log('callbackFromTeacherSelfList');
        this.setState({
            roomId: roomid,
            currentTeacherId: id,
            currentTeacherName: name

        }, () => {

            this.setState({ message: <ReportEvaluateTeacher roomId={this.state.roomId} teacherId={this.state.currentTeacherId} /> });
            this.setState({
                filter:
                    <Row className="m-auto" >
                        <Col className="p-0 p-md-2">
                            <Row>
                                <Col style={{ "fontSize": '14px' }}>
                                    <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('self')}>ครูประเมินตัวเอง ></span> <span style={{ color: '#848DA3' }} className="font-sarabun-bold">{this.state.currentTeacherName}</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            });

        });

    }


    studentList() {

        this.setState({ message: <ReportEvaluateStudentList roomId={this.state.roomId} referenceCallback={this.callbackFromPersonEvaluateReport.bind(this)} /> });
    }

    selfEvaluate() {

        if (AuthService.getUserRole() !== 'teacher') {
            console.log(22222)

            this.setState({ message: <ReportEvaluateTeacherList page='self' roomId={this.state.roomId} referenceCallback={this.callbackFromTeacherSelfList.bind(this)} /> });
        } else {
            console.log(43444444)

            this.setState({ message: <ReportEvaluateTeacher roomId={this.state.roomId} teacherId={this.state.currentTeacherId} /> });
        }

    }

    studentEvaluateTeacher() {


        if (AuthService.getUserRole() !== 'teacher') {
            console.log(11111)
            this.setState({ message: <ReportEvaluateTeacherList2 page='student' roomId={this.state.roomId} referenceCallback={this.callbackFromStudentEvaluateTeacher.bind(this)} /> });

        } else {
            console.log(33333)

            this.setState({ message: <ReportStudentEvaluateTeacher roomId={this.state.roomId} teacherId={this.state.currentTeacherId} /> });
        }

    }

    // teacherSelfList() {
    //     this.setState({ message: <ReportEvaluateTeacherList  roomId={this.state.roomId} referenceCallback={this.callbackFromTeacherSelfList.bind(this)}/> });

    // }

    studentEvaluateTeacherDetail() {
        this.setState({ message: <ReportStudentEvaluateTeacher roomId={this.state.roomId} teacherId={this.state.currentTeacherId} /> });
    }

    studentintro() {
        this.setState({ message: <ReportStudentIntro roomId={this.state.roomId} currentStudentId={this.state.currentStudentId} currentStudentName={this.state.currentStudentName} referenceCallback={this.callbackFromStudentintro.bind(this)} /> });
    }

    studentResult(code) {
        this.setState({ message: <ReportEvaluateStudentResult roomId={this.state.roomId} currentStudentId={this.state.currentStudentId} currentStudentName={this.state.currentStudentName} code={code.code} /> });
    }

    selfDevelopment() {
        this.setState({ message: <ReportSelfDevelopment currentStudentId={this.state.currentStudentId} currentStudentName={this.state.currentStudentName} /> });
    }


    getFilter(tabKey, inputs = null) {
        this.setState({ tabKey: tabKey });
        console.log('tabKey', tabKey)
        this.setState({
            classFillter: 'bg-white'
        });
        if (tabKey === 'student') {
            this.setState({ report1: btnEvaluate1(tabKey) });
            this.setState({ report2: btnEvaluate2(tabKey) });
            this.setState({ report3: btnEvaluate3(tabKey) });

            this.setState({
                filter: ''
            });
        } else if (tabKey === 'self') {

            if (AuthService.getUserRole() !== 'teacher') {
                this.setState({
                    classFillter: 'bg-white'
                });
            } else {
                this.setState({
                    classFillter: 'bg-light-blue'
                });
            }
            this.setState({ report1: btnEvaluate1(tabKey) });
            this.setState({ report2: btnEvaluate2(tabKey) });
            this.setState({ report3: btnEvaluate3(tabKey) });


            this.setState({
                filter:
                    <Row className="p-0 m-auto" ></Row>
            });

        } else if (tabKey === 'studentEvaluateTeacher') {

            if (AuthService.getUserRole() !== 'teacher') {
                this.setState({
                    classFillter: 'bg-white'
                });
            } else {
                this.setState({
                    classFillter: 'bg-light-blue'
                });
            }

            this.setState({ report1: btnEvaluate1(tabKey) });
            this.setState({ report2: btnEvaluate2(tabKey) });
            this.setState({ report3: btnEvaluate3(tabKey) });
            this.setState({
                filter:
                    <Row className="p-0 m-auto" ></Row>
            });

        } else if (tabKey === 'studentEvaluateTeacherDetail') {

            this.setState({
                classFillter: 'bg-white'
            });

            this.setState({
                filter:
                    <Row className="m-auto" >
                        <Col className="p-0 p-md-2">
                            <Row>
                                <Col style={{ "fontSize": '14px' }}>
                                    <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('studentEvaluateTeacher')}>มุมมองของนักเรียน</span> <span style={{ color: '#848DA3' }} className="font-sarabun-bold">{this.state.currentTeacherName}</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            });



        } else if (tabKey === 'studentintro') {

            console.log(this.state.currentStudentName);
            this.setState({ report1: btnEvaluate1('student') });
            this.setState({ report2: btnEvaluate2('student') });
            this.setState({ report3: btnEvaluate3(tabKey) });
            this.setState({
                filter:
                    <Row className="m-auto" >
                        <Col className="p-0 p-md-2">
                            <Row>
                                <Col style={{ "fontSize": '14px' }}>
                                    <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('student')}>ประเมินนักเรียน</span> <span style={{ color: '#848DA3' }} className="font-sarabun-bold">{this.state.currentStudentName}</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            });
        } else if (tabKey === 'studentself') {
            this.setState({ report1: btnEvaluate1('student') });
            this.setState({ report2: btnEvaluate2('student') });
            this.setState({ report3: btnEvaluate3(tabKey) });
            this.setState({
                filter:
                    <Row className="m-auto" >
                        <Col className="p-0 p-md-2">
                            <Row>
                                <Col style={{ "fontSize": '14px' }}>
                                    <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('student')}>ประเมินนักเรียน ></span> <span className="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('studentintro')}>{this.state.currentStudentName} > </span><span style={{ color: '#848DA3' }} className="font-sarabun-bold"> มุมมองตัวเอง</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            });

        } else if (tabKey === 'studentteacher') {
            this.setState({ report1: btnEvaluate1('student') });
            this.setState({ report2: btnEvaluate2('student') });
            this.setState({ report3: btnEvaluate3(tabKey) });
            this.setState({
                filter:
                    <Row className="m-auto" >
                        <Col className="p-0 p-md-2">
                            <Row>
                                <Col style={{ "fontSize": '14px' }}>
                                    <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('student')}>ประเมินนักเรียน ></span> <span className="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('studentintro')}>{this.state.currentStudentName} > </span><span style={{ color: '#848DA3' }} className="font-sarabun-bold"> มุมมองคุณครู</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            });

        } else if (tabKey === 'studentfriend') {
            this.setState({ report1: btnEvaluate1('student') });
            this.setState({ report2: btnEvaluate2('student') });
            this.setState({ report3: btnEvaluate3(tabKey) });
            this.setState({
                filter:
                    <Row className="m-auto" >
                        <Col className="p-0 p-md-2">
                            <Row>
                                <Col style={{ "fontSize": '14px' }}>
                                    <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('student')}>ประเมินนักเรียน ></span> <span className="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('studentintro')}>{this.state.currentStudentName} > </span><span style={{ color: '#848DA3' }} className="font-sarabun-bold"> มุมมองเพื่อนๆ</span>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
            });

        } else if (tabKey === 'selfDevelopment') {
            this.setState({ report1: btnEvaluate1('student') });
            this.setState({ report2: btnEvaluate2('student') });
            this.setState({ report3: btnEvaluate3(tabKey) });
            this.setState({
                filter: <Row className="m-auto" >
                    <Col className="p-0 p-md-2">
                        <Row>
                            <Col style={{ "fontSize": '14px' }}>
                                <span class="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('student')}>ประเมินนักเรียน ></span> <span className="gray-text4 click-pointer font-sarabun-bold" onClick={() => this.updateContent('studentintro')}>{this.state.currentStudentName} > </span><span style={{ color: '#848DA3' }} className="font-sarabun-bold"> แนวทางการพัฒนาตัวเอง</span>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            });
        }
    }

    updateContent(menu, inputs = []) {
        var data = '';
        console.log('updateContent', menu);
        if (menu === 'student') {
            this.studentList();
            this.getFilter(menu);
        } else if (menu === 'self') {
            this.selfEvaluate()
            this.getFilter(menu);
        } else if (menu === 'studentEvaluateTeacherDetail') {
            this.studentEvaluateTeacherDetail()
            this.getFilter(menu);
        }
        // else if(menu === 'teacherSelfList') {  
        //     this.teacherSelfList()   
        //     this.getFilter(menu);             

        // } 
        else if (menu === 'studentEvaluateTeacher') {
            this.studentEvaluateTeacher()
            this.getFilter(menu);
        } else if (menu === 'studentintro') {
            this.studentintro()
            this.getFilter(menu);
        } else if (menu === 'studentResult') {
            this.studentResult(inputs)
            this.getFilter(inputs.code);
        } else if (menu === 'selfDevelopment') {
            console.log('selfDevelopment');
            this.selfDevelopment();
            this.getFilter(inputs.code);
        }

    }

    render() {
        return (
            <div className={`evaluate-report`}>
                <Helmet>
                    <title>การประเมินอุปนิสัยเชิงบวกของนักเรียน และตัวครู - Mindsetmaker.co</title>
                    <meta property="og:title" content={`การประเมินอุปนิสัยเชิงบวกของนักเรียน และตัวครู - Mindsetmaker.co`} />
                    <meta property="og:description" content={`กิจกรรมประเมินด้วยการค้นหาสิ่งดีๆ ในช่วงเวลาที่ผ่านมา เพื่อค้นพบอุปนิสัยเชิงบวกในตัวเรา เพื่อนๆและคุณครู`} />
                </Helmet>
                <Row className="border-bottom-blue">
                    <div className="pt-3 pb-0 btn-main-group text-center w-100">
                        <Button variant="m-2 py-md-1 btn-repot font-sarabun pt-3" className={this.state.report1} onClick={() => this.updateContent('student')}>ประเมินนักเรียน</Button>
                        {(this.state.currentTeacherId === this.state.teacherId) ? (
                            <Button variant="m-2 py-md-1 btn-repot font-sarabun pt-3" className={this.state.report2} onClick={() => this.updateContent('self')}>{this.state.menuText}</Button>
                        ) : (

                            <Button variant="m-2 py-md-1 btn-repot font-sarabun pt-3" className={this.state.report2} style={{ "cursor": "unset" }} onClick={() => this.updateContent('self')}>{this.state.menuText}</Button>
                        )
                        }
                        <Button variant="m-2 py-md-1 btn-repot font-sarabun pt-3" className={this.state.report3} onClick={() => this.updateContent('studentEvaluateTeacher')}>มุมมองของนักเรียน</Button>
                    </div>
                </Row>
                <Row>
                    <div className={`py-0 px-0 w-100 ${this.state.classMainBg} `}>
                        <div className={`px-4 pt-3 ${this.state.classFillter} ${this.state.classShadow}`} >
                            <div className="main-detail">
                                {this.state.filter}
                            </div>
                        </div>
                        <div className="text-center data-div px-3 font-sarabun">
                            {this.state.message}
                        </div>
                    </div>
                </Row>
            </div>

        );
    }

}


function btnEvaluate1(selectMenu) {
    if (selectMenu === 'student') {
        return "btn-mm-blue";
    } else {
        return "btn-mm-outline-blue";
    }
}

function btnEvaluate2(selectMenu) {
    if (selectMenu === 'self') {
        return "btn-mm-blue";
    } else {
        return "btn-mm-outline-blue";
    }
}


function btnEvaluate3(selectMenu) {
    if (selectMenu === 'studentEvaluateTeacher') {
        return "btn-mm-blue";
    } else {
        return "btn-mm-outline-blue";
    }
}


export default withRouter(ReportFriendshipOverview);